module.exports = __webpack_public_path__ + "static/img/isp_img_3.2489156.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/isp_img_3.svg
// module id = t7c5
// module chunks = 0